import styled from "styled-components"

export const StyledMobileAndDesktopFilterMenuWrapper = styled.div`
  background: #fff;
  position: fixed;
  z-index: 100;
  height: 100vh;
  width: 100vw;
  animation-name: appearance;
  animation-duration: 1s;

  @keyframes appearance {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.99;
    }
  }
`

export const StyledMobileFilterContainer = styled.div`
  padding-left: 23px;
`

export const StyledFilterHeader = styled.header`
  display: flex;
  padding: 11px 24px 13px 27px;
  justify-content: space-between;
`

export const StyledFilterHeaderConfirmButton = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid #86723e;
  cursor: pointer;
  background: #fff !important;
`

export const StyledFilterTitle = styled.h2`
  font-family: Nunito Sans;
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.56px;
`

export const StyledCategoryTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.8px;
  margin: 15px 0;
`

